<template lang="pug">
	.creative-settings
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="$tCaption('Settings')", :width="640", :autosize="true", :hideOnOutsideClick="false")
			.flex-col.space-large
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Displaying')}}
					DxCheckBox(:text="$tCaption('Show links always in tracker')", :value.sync="showLinksAlways.value")
				.flex-col.space
					.font-small.upper.grey {{$tCaption('Tools')}}
					.flex-row.space
						DxButton(:text="$tCaption('Cache manager')", @click="showCacheManager", icon="fas fa-database")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
		CacheManager(v-if="creative", ref="cacheManager", :metrics="cacheMetrics")
</template>

<script>	
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import CacheManager from 'app-core/LocalDbManager.vue';
	import DxCheckBox from 'devextreme-vue/check-box';
	import storage from 'storage';

	export default {
		translationCategory: 'creative.CreativeSettings',
		name: 'creative-settings',
		components: {
			Popup, DxButton, CacheManager, DxCheckBox
		},
		props: ['creative'],
		computed: {
			cacheMetrics() {
				return [{ name: this.$tCaption('Current creative'), condition: (f) => f?.creativeId === this.creative?.Oid }]
			},
		},
		data() {
			return {
				popupVisible: false,
				showLinksAlways: storage.prop('showLinksAlways', void 0, false)
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeSettings = this;
		},
		methods: {
			show() {
				this.popupVisible = false;
				setImmediate(() => this.popupVisible = true);
			},
			showCacheManager() {
				this.$refs.cacheManager.show(this.creative?.Oid);
			}
		}
	};
</script>
<style lang='scss'>
	.creative-settings {
	}
</style>
